/** @jsx jsx */
import React from "react"
import { jsx } from "@emotion/core"
import { Link } from "../components/Link"
import HeroImage from "../assets/hero-image-mystic-parker.jpg"
import TESTIMONIALS from "../assets/testimonials.json"

import Layout from "../components/layout"

import SEO from "../components/seo"
import {
  colors,
  typography,
  flex,
  GLOBAL_SHADOW,
  onMedia,
  MAX_TYPE_WIDTH,
  White100Type,
  touchBoundary,
} from "../styles"
import { ContentArea } from "../components/ContentArea"
import { LogoMaster } from "../components/LogoMaster"
import { SecondaryAction } from "../components/SecondaryAction"
import { Footer } from "../components/Footer"
import { PrimaryAction } from "../components/PrimaryAction"
import { PaperMotif } from "../components/PaperMotif"
import { Testimonial } from "../components/Testimonial"
import { SectionBlock } from "../components/SectionBlock"
import { Menu } from "../components/Menu"
import { Heading2 } from "../components/Heading2"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    {/* <Menu /> */}
    <header
      css={{
        width: "100%",
        minHeight: "100vh",
        position: "relative",
        "&:before": {
          content: "''",
          position: "absolute",
          zIndex: 0,

          width: "100%",
          height: "100%",

          backgroundImage: `url(${HeroImage})`,
          backgroundPosition: "left center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          filter: "brightness(0.66)", // blur(2px)?
        },
      }}
    >
      <ContentArea
        css={{
          ...flex(),
          alignItems: "flex-start",
          justifyContent: "center",

          position: "relative",

          width: "100%",
          padding: "1rem",
          minHeight: "100vh",
        }}
      >
        <Link to={"/"}>
          <PaperMotif
            css={[
              {
                alignSelf: "center",

                position: "absolute",
                top: "0",

                padding: "1rem",
              },
              onMedia("min-width: 680px", {
                left: "1rem",
              }),
            ]}
          >
            <LogoMaster
              color={colors.BLUE}
              css={{
                width: "5rem",
              }}
            />
          </PaperMotif>
        </Link>
        <PaperMotif
          // Creates space in the DOM to prevent overlap with logo heading
          css={[
            {
              visibility: "hidden",
              padding: "1rem",
            },
          ]}
        >
          <LogoMaster
            color={colors.BLUE}
            css={{
              width: "5rem",
            }}
          />
        </PaperMotif>

        <h1
          css={[
            {
              ...White100Type,
              textShadow: GLOBAL_SHADOW,
            },
            onMedia("min-width: 700px", {
              maxWidth: "70%",
            }),
          ]}
        >
          Full service, on-demand printing and mailing for business owners and
          marketing professionals.
        </h1>

        <PrimaryAction
          href="tel:7813214948"
          css={{ alignSelf: "start", margin: "1rem 0" }}
        >
          781-321-4948
        </PrimaryAction>
        <SecondaryAction
          href="https://mysticparker.espwebsite.com/"
          css={{
            alignSelf: "start",
            margin: "1rem 0",
            backgroundColor: colors.BACKGROUND_WHITE,
            color: colors.BLUE,
          }}
        >
          Shop Promo Products
        </SecondaryAction>
      </ContentArea>
    </header>
    <main>
      <SectionBlock>
        <ContentArea
          css={{
            ...flex("column"),
            alignItems: "center",
            justifyContent: "center",

            margin: "25vh auto",
            padding: "1rem",

            fontFamily: typography.UNIVIA,
          }}
        >
          <Heading2>Your One Stop Solution.</Heading2>

          <p css={MAX_TYPE_WIDTH}>
            We pride ourselves on providing our clients with a wide range of
            solutions that solve their communication needs… today, tommorow and
            into the future…
          </p>

          <PaperMotif css={{ margin: touchBoundary }}>
            {TESTIMONIALS.filter(t => t.by.match("John Silvio")).map(
              ({ by, highlight, ...rest }) => (
                <Testimonial css={MAX_TYPE_WIDTH} from={by} {...rest} key={by}>
                  {highlight}
                </Testimonial>
              )
            )}
          </PaperMotif>
        </ContentArea>
      </SectionBlock>

      <SectionBlock>
        <ContentArea
          css={[
            {
              ...flex("column"),
              alignItems: "center",
              justifyContent: "center",

              margin: "25vh auto",
              padding: "1rem",

              color: colors.DARK_GRAY,
            },
          ]}
        >
          <Heading2>Speak to a human.</Heading2>

          <p css={[{ color: "inherit" }, MAX_TYPE_WIDTH]}>
            Give us a call, or send us an email. You’ll here directly from a
            member of our team.
          </p>

          <SecondaryAction
            href={"mailto:info@mysticparker.com"}
            // css={{ backgroundColor: colors.LIGHT_GRAY }}
          >
            info@mysticparker.com
          </SecondaryAction>
          <br />
          <span css={{ color: colors.MID_GRAY }}>&mdash; or &mdash;</span>
          <br />
          <PrimaryAction href={"tel:7813214948"}>781-321-4948</PrimaryAction>
        </ContentArea>
      </SectionBlock>
    </main>
    <Footer />
  </Layout>
)

export default IndexPage
